import type { Message, MessageStatus } from "../types";

const SENT_OUTBOUND_STATUSES = new Set<MessageStatus>([
  "sent",
  "delivered",
  "read"
]);

export const isReplyableEmail = (message: Message): boolean => {
  if (message.channel !== "email") return false;
  if (message.direction === "inbound") return true;
  return SENT_OUTBOUND_STATUSES.has(message.status);
};
